import React from 'react';
import Text from '@molecules/Text';
import BEButton from '@molecules/Button/Button';
import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import { useStore } from '@data/other/withStore';
import { useTranslation } from 'react-i18next';

const ModalTermsAndConditions = ({ ...props }: ModalProps) => {
  const { property } = useStore();
  const { t } = useTranslation();

  return (
    <ModalComponent
      {...props}
      title={t('terms-and-conditions')}
      buttons={(props) => (
        <BEButton variant="outline" onClick={props.onOk}>
          {t('cancel')}
        </BEButton>
      )}
    >
      <Text html={property.model?.termsAndConditions?.getText() || ''} />
    </ModalComponent>
  );
};

export default ModalTermsAndConditions;
